import React from 'react';

interface GlassOptionCardProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

export function GlassOptionCard({
  selected,
  onClick,
  children,
  className = '',
}: GlassOptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-left rounded-2xl p-5 transition-all duration-200 cursor-pointer ${className}`}
      style={{
        background: selected
          ? 'rgba(255, 255, 255, 0.16)'
          : 'rgba(255, 255, 255, 0.05)',
        border: selected
          ? '1px solid rgba(255, 255, 255, 0.35)'
          : '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: selected
          ? '0 2px 12px rgba(0, 0, 0, 0.1)'
          : 'none',
      }}
      onMouseEnter={(e) => {
        if (!selected) {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.18)';
        }
      }}
      onMouseLeave={(e) => {
        if (!selected) {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
        }
      }}
    >
      {children}
    </button>
  );
}
